export const getProductTypeText = (productType: string[]) => {
    return productType.join(', ')
        .replace('BOOK', '도서')
        .replace('GENERAL', '잡화');
}
